import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dogHighFiveLarge } from 'assets/images';
import { Header } from 'components/Layout/Header/Header';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import { Button } from 'components/UI/Button/Button';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { goToPetParentPortal } from 'utils/petParentPortal';

import classes from './AddonsMode.module.scss';

interface AddonsModeSuccessProps {
    bookingId: number;
}

/** Figma 1882:10210. */
export const AddonsModeSuccess: React.FC<AddonsModeSuccessProps> = ({ bookingId }) => {
    const marketplace = useMarketplace();

    return (
        <TwoColumnsLayout header={<Header logo={marketplace.logo} progress={100} />}>
            <LeftColumn contentClassName={classes.centered}>
                <span className={classes.successIcon}>
                    <FontAwesomeIcon icon={faCheck} />
                </span>

                <h1 className={classes.successTitle}>Your extras are all set!</h1>

                <p className={classes.successText}>
                    Your selected extras have been added to your booking. Review the updated details
                    in the Pet Parent Portal.
                </p>

                <Button
                    className={classes.centeredAction}
                    onClick={() => goToPetParentPortal(marketplace.slug, bookingId)}
                >
                    Go to Pet Parent Portal
                </Button>
            </LeftColumn>

            <div className={classes.successImage}>
                <img src={dogHighFiveLarge} alt="" />
            </div>
        </TwoColumnsLayout>
    );
};
